import { api, encodeFileName } from 'utility';
import {
  getTicketCategoryUrl,
  getTicketInfoUrl,
  getTicketInfoDiscussionsUrl,
  getCreateDiscussionUrl,
  getCreateTicketUrl,
  getUploadFileTicketUrl,
  getHistoryVersionsUrl,
  getFaqUrl,
  getTicketWorkItemFieldsUrl,
  getTicketingSale,
  getTicketingSupport,
  getTicketingSaleRequest,
  getTicketingSupportRequest,
  getCancellTicketSaleUrl,
  getCancellTicketSupportUrl,
  getCloseTicketSaleUrl,
  getCloseTicketSupportUrl,
  getTicketFullSupport,
  setFailStatusTicket,
  setApprovalStatusTicket,
  getTicketFullSale,
  getAttachFileDiscussionUrl
} from 'URLs';
class Services {

  postFailStatus(workItemId, data) {
    return api.post(setFailStatusTicket(workItemId), data).then((res) => res.data);
  }

  postApprovalStatus(id) {
    return api.post(setApprovalStatusTicket(id)).then((res) => res.data);
  }

  getTicketFullSupport() {
    return api.get(getTicketFullSupport()).then((res) => res.data);
  }
  getTicketFullSale() {
    return api.get(getTicketFullSale()).then((res) => res.data);
  }
  getTicketingSaleRequest(params, id) {
    return api.get(getTicketingSaleRequest(id), { params }).then((res) => res.data);
  }


  getTicketingSupportRequest(params, id) {
    return api.get(getTicketingSupportRequest(id), { params }).then((res) => res.data);
  }


  getCategories(params) {
    return api.get(getTicketCategoryUrl(), { params }).then((res) => res.data);
  }

  getRequestInfo(workItemPid, projectId) {
    return api.get(getTicketInfoUrl(projectId, workItemPid)).then((res) => res.data);
  }

  getDiscussions(workItemPid, projectId, params) {
    return api
      .get(getTicketInfoDiscussionsUrl(projectId, workItemPid), { params })
      .then((res) => res.data);
  }

  updateCancelSupportTicket(workItemPid, projectId, data) {
    return api.put(getCancellTicketSupportUrl(projectId, workItemPid), data);
  }

  updateCancelSaleTicket(workItemPid, projectId, data) {
    return api.put(getCancellTicketSaleUrl(projectId, workItemPid), data);
  }

  updateCloseSaleTicket(workItemPid, projectId, data) {
    return api.put(getCloseTicketSaleUrl(projectId, workItemPid), data);
  }
  updateCloseSupportTicket(workItemPid, projectId, data) {
    return api.put(getCloseTicketSupportUrl(projectId, workItemPid), data);
  }

  addDiscussion(workItemPid, projectId, ticketId, data) {
    return api.post(getCreateDiscussionUrl(projectId, workItemPid), { ...data, workItemId: ticketId });
  }
  attachDiscussion(workItemPid, projectId, ticketId, data) {
    return api.post(getAttachFileDiscussionUrl(projectId, workItemPid), { ...data, workItemId: ticketId });
  }
  getCategories(params) {
    return api.get(getTicketCategoryUrl(), { params }).then((res) => res.data);
  }
  createTicket(category, projectId, data) {
    return api.post(getCreateTicketUrl(category, projectId), data).then((res) => res.data);
  }
  //todo check
  uploadFileTicket(data, name, type) {
    return api.post(getUploadFileTicketUrl(), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'File-Type': type,
        'file-name': encodeFileName(name)
      },
    });
  }
  getHistoryVersions() {
    return api.get(getHistoryVersionsUrl()).then((res) => res.data);
  };
  /**
   * دریافت لیست سوالات متداول - در منوی پشتیبانی - تب سوالات متداول استفاده میشود
   */
  getFaqs() {
    return api.get(getFaqUrl()).then((res) => res.data);
  };

  getTicketWorkItemFields(workItemId, params) {
    return api.get(getTicketWorkItemFieldsUrl(workItemId), { params }).then((res) => res.data);
  }



  // سرویس دریافت دیتای تیکت های فروشنده 
  getTicketingSale() {
    return api.get(getTicketingSale()).then((res) => res.data);
  };

  // سرویس دریافت دیتای تیکت های پشتیبانی 
  getTicketingSupport() {
    return api.get(getTicketingSupport()).then((res) => res.data);
  };

}

export default new Services();
